import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { authFetch } from '../../../utils/authFetch';

export const fetchAgencyAgents = createAsyncThunk(
  'agencyAgents/fetchAll',
  async (team = null, { rejectWithValue }) => {
    try {
      const qs = team ? `?team=${team}` : '';
      const response = await authFetch(`/.netlify/functions/agency-agents-list${qs}`, { method: 'GET' });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        return rejectWithValue(err.error || `HTTP ${response.status}`);
      }
      return await response.json();
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchFrameworks = createAsyncThunk(
  'agencyAgents/fetchFrameworks',
  async (domain = null, { rejectWithValue }) => {
    try {
      const qs = domain ? `?domain=${domain}` : '';
      const response = await authFetch(`/.netlify/functions/agency-frameworks-list${qs}`, { method: 'GET' });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        return rejectWithValue(err.error || `HTTP ${response.status}`);
      }
      return await response.json();
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchTools = createAsyncThunk(
  'agencyAgents/fetchTools',
  async (_, { rejectWithValue }) => {
    try {
      const [toolsRes, skillsRes] = await Promise.all([
        authFetch('/.netlify/functions/agency-tools-list', { method: 'GET' }),
        authFetch('/.netlify/functions/agency-tools-list?type=skills', { method: 'GET' }),
      ]);
      const tools = toolsRes.ok ? (await toolsRes.json()).tools || [] : [];
      const skills = skillsRes.ok ? (await skillsRes.json()).skills || [] : [];
      return { tools, skills };
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const agencyAgentsSlice = createSlice({
  name: 'agencyAgents',
  initialState: {
    agents: [],
    frameworks: [],
    tools: [],
    skills: [],
    permissions: { canEdit: false },
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAgencyAgents.pending, (state) => { state.loading = true; })
      .addCase(fetchAgencyAgents.fulfilled, (state, action) => {
        state.loading = false;
        state.agents = action.payload.agents || [];
        state.permissions = action.payload.permissions || { canEdit: false };
      })
      .addCase(fetchAgencyAgents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchFrameworks.fulfilled, (state, action) => {
        state.frameworks = action.payload.frameworks || [];
      })
      .addCase(fetchTools.fulfilled, (state, action) => {
        state.tools = action.payload.tools || [];
        state.skills = action.payload.skills || [];
      });
  },
});

export const selectAgencyAgents = (state) => state.agencyAgents?.agents || [];
export const selectFrameworks = (state) => state.agencyAgents?.frameworks || [];
export const selectTools = (state) => state.agencyAgents?.tools || [];
export const selectSkills = (state) => state.agencyAgents?.skills || [];
export default agencyAgentsSlice.reducer;
